import { couplingValues } from '../constants/couplingValues';
export function rangeFromSignal(signal, options) {
    const { nucleus = '1h', frequency = 400 } = options;
    const { tolerance = getTolerance(nucleus) / frequency } = options;
    let halfWidth = 0;
    const { js: jCouplings = [], multiplicity } = signal;
    if (jCouplings.length > 0) {
        for (const js of jCouplings) {
            const { coupling, multiplicity = 'd' } = js;
            halfWidth += (couplingValues[multiplicity] * coupling) / frequency;
        }
    }
    else if (multiplicity === 'm') {
        halfWidth = 16 / frequency;
    }
    else if (multiplicity === 'b' || multiplicity === 'br s') {
        halfWidth = 7 / frequency;
    }
    halfWidth = tolerance + halfWidth / 2;
    return {
        from: signal.delta - halfWidth,
        to: signal.delta + halfWidth,
    };
}
function getTolerance(nucleus) {
    switch (nucleus.toLocaleLowerCase()) {
        case '1h':
            return 1.5;
        case '13C':
            return 3;
        default:
            return 2;
    }
}
//# sourceMappingURL=rangeFromSignal.js.map